
namespace TabAurous.Production {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MergingDialog extends _Ext.TransDialog<MergingRow, any> {
        
        protected getFormKey() { return MergingForm.formKey; }
        protected getIdProperty() { return MergingRow.idProperty; }
        protected getLocalTextPrefix() { return MergingRow.localTextPrefix; }
        protected getNameProperty() { return MergingRow.nameProperty; }
        protected getService() { return MergingService.baseUrl; }
        protected getDeletePermission() { return MergingRow.deletePermission; }
        protected getInsertPermission() { return MergingRow.insertPermission; }
        protected getUpdatePermission() { return MergingRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new MergingForm(this.idPrefix);
        public Closing: boolean;
        bagselected: any;
        bomDetails: any[];
        splitEmptyBag: boolean;
        splitSingleItem: boolean;
        allowSplitParts: boolean;

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions); 
            Config.height = 150;
            q.initItemEditor(this, this.form.Details, Config);
            //Make grid full width
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight); 
            //q.hideEditorToolbar(this.form.Details);
            q.hideEditorLabel(this.form.Details);

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
            );
        }


        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                if (this.form.Details.getItems().length == 0) {

                    if (this.form.DepartmentId.value == "" || this.form.DepartmentId.value == undefined) {
                        q.Alert("Invalid", "Please Select Department to Proceed", 2000, false);
                        return;
                    }
                    var grid = WIPMovementSelectGridForMerging;
                    var filters: _Ext.SelectGridFilters = {
                        DepartmentId: parseInt(this.form.DepartmentId.value)
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {

                        if (selectedItems.length > 0) {
                            this.form.BagNo.value = selectedItems[0].BagNo;
                          
                            this.form.Weight.value = selectedItems[0].Parts;
                            this.form.Pieces.value =  selectedItems[0].Pieces;
                            this.form.Weight.value = selectedItems[0].Weight;
                            

                            let bomdetails;
                            WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });
                            var newbomdetails = [];
                            for (var i = 0; i < bomdetails.length; i++) {
                                var value = bomdetails[i];

                                var newbom: MFGTransactionBOMRow = {
                                    AttributeId: value.AttributeId,
                                    ItemTypeId: value.ItemTypeId,
                                    CalcOnId: value.CalcOnId,
                                    ProductCode: value.ProductCode,
                                    Attribute: value.Attribute,
                                    BomProductId: value.ProductId,
                                    BagNo: value.BagNo,
                                    ProductId: value.ProductId,
                                    FromDeptId: value.DepartmentId,
                                    FromWorkerId: value.EmployeeId,
                                    Pieces: value.Pieces,
                                    Line_No: value.Line_No,
                                    PureWeight: value.PureWeight,
                                    Purity: value.Purity == null ? 0 : value.Purity,
                                    Weight: value.Weight,
                                    RefTransId: value.TransId,
                                    RefVoucherId: value.VoucherTypeId
                                };
                                newbomdetails.push(newbom);

                            }
                            this.bagselected = selectedItems[0];
                            this.bomDetails = newbomdetails;
                            //this.CalculateTotals();
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        } 
         
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
 

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                var refid = WIPMovementRow.getLookup().items.filter(x => x.RefTransId == parseInt(this.form.TransId.value) && x.RefVoucherId == this.form.VoucherTypeId.value)[0];
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Details.element, false);
                    //this.form.Details.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        MergingService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }

    }
}